import React from 'react';
import { Fragment } from 'react';

const QuickSearchLinks = ({ links }) => {
  return (
    <>
      {links.map((linkgroup, i) => (
        <div key={`linkgroup-${i}`} className="quick-search-links__links">
          {linkgroup.map((link, i) => (
            <Fragment key={`linkgroup-link-${i}`}>
              {link.url === null ? (
                <div className="quick-search-links__link-item">
                  <span className="quick-search-links__link-item__title">
                    {link.name}
                  </span>
                </div>
              ) : (
                <div className="quick-search-links__link-item">
                  <a href={link.url}>{link.name}</a>
                </div>
              )}
            </Fragment>
          ))}
        </div>
      ))}
    </>
  );
};

export default QuickSearchLinks;
